import React from "react";
import Index from "../anonymizer/Index";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import LoginScreen from "../auth/Login";

const Anonymizer = () => {
  return (
    <div>
     <AuthenticatedTemplate>
      <Index />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <LoginScreen />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Anonymizer;
